import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
	selector: 'app-remove-image',
	templateUrl: './remove-image.component.html',
	styleUrls: ['./remove-image.component.scss']
})
export class RemoveImageComponent implements OnInit {

	constructor(
		public dialogRef: MatDialogRef<RemoveImageComponent>,
		@Inject(MAT_DIALOG_DATA) public dailogData:any)
	{
		// THIS IS INTENTIONAL
	}

	ngOnInit(): void {
		// THIS IS INTENTIONAL
	}

	// ON CLICK REMOVE IMAGE TO CLOSE WINDOW AND SET RETURN DATA.
	onClickRemoveImage = () => {
		this.dialogRef.close({
			specimenCode : this.dailogData.specimenCode,
			specLink : this.dailogData.specLink,
			spec : this.dailogData.spec,
			imageNumber : this.dailogData.imageNumber,
			mailing : this.dailogData.mailing
		});
	}
}